exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-card{border:1px solid #ddd;margin-top:16px;padding:16px;border-radius:8px}.payment-card-title{font-size:20px;font-weight:500}.payment-currency-btn .btn__content{width:60px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5073ad08","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/customer/payWithFib.vue
// module id = 876
// module chunks = 0